import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIDashboardPage from 'UIComponents/page/UIDashboardPage';
import UISection from 'UIComponents/section/UISection';
import { NavMarker } from 'react-rhumb';
import ApiError from '../../../components/Errors/ApiError';
import NoResultsError from '../../../components/Errors/NoResultsError';
import LessonCardContainer from '../../../components/LessonCard/LessonCardContainer';
import ResultsStatusBar from '../../../components/ResultsStatusBar';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import MobileFilterSection from '../../../containers/TracksPage/MobileFilterSection';
import TrackCardContainer from '../../../containers/TracksPage/TrackCardContainer';
// @ts-expect-error Could not find a declaration file for module
import TracksTopFiltersContainer from '../../../containers/TracksPage/TracksTopFiltersContainer';
import styled, { useMediaQuery, theme, mediaQuery, css } from 'academy-common-lib/utils/Styling';
import { useSearchParamCatalogSearch } from '../searchQueries';
import { CatalogSearchPagination } from './CatalogSearchPagination';
import UICardGrid from 'UIComponents/card/UICardGrid';
import { useState } from 'react';
import { useDisplayedData } from '../../table';
//@ts-expect-error Could not find a declaration file for module
import PaginatedUICardGrid from '../../../containers/MyLearningPage/PaginatedUICardGrid';
import { ShortCard } from '../../cards';

/* Removes border at top of UIDashboard Page */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CatalogPageWrapper = styled.div.withConfig({
  displayName: "CatalogSearchResults__CatalogPageWrapper",
  componentId: "vo9sp-0"
})(["[class^='UIAbstractPageTemplate'] > section + div{border-top:0;}"]);
const CardsContainer = styled.div.withConfig({
  displayName: "CatalogSearchResults__CardsContainer",
  componentId: "vo9sp-1"
})(["padding-top:15px;", ""], mediaQuery('mobile', css(["padding-top:0;"])));
const UICardGridStyled = styled(UICardGrid).withConfig({
  displayName: "CatalogSearchResults__UICardGridStyled",
  componentId: "vo9sp-2"
})(["grid-template-columns:repeat(auto-fill,minmax(298px,1fr));"]);
const pageSize = 12;
export const CatalogSearchResults = ({
  banners,
  isPartnerPage,
  pageUrlFragment
}) => {
  const {
    tracksLessonsSearchQueryData,
    tracksLessonsSearchResultsTotal = 0,
    tracksLessonsSearchQueryLoading,
    tracksLessonsSearchQueryError,
    searchQueryParams,
    sendSearchFeedback,
    mustPaginateLocally
  } = useSearchParamCatalogSearch({
    isPartnerPage,
    pageSize
  });
  const [page, setPage] = useState(1);
  const {
    pageNumber
  } = searchQueryParams;
  const pageCount = Math.round(tracksLessonsSearchResultsTotal / pageSize);
  const pageMultiplier = pageNumber * pageSize;
  const endCard = pageMultiplier > tracksLessonsSearchResultsTotal ? tracksLessonsSearchResultsTotal : pageMultiplier;
  const startCard = pageMultiplier - pageSize + 1;
  const {
    tracksLessonsSearchQueryData: data = []
  } = useDisplayedData({
    tracksLessonsSearchQueryData
  }, {
    loading: tracksLessonsSearchQueryLoading,
    parameters: {
      isPartnerPage,
      pageSize
    }
  }) || {};
  const {
    isMobile
  } = useMediaQuery();
  const cards = data.map(({
    id,
    contentType,
    resultMLOptionId,
    language,
    data: {
      language: dataLanguage
    }
  }, index) => {
    return contentType === 'SHORT_FORM_CONTENT' && (language || dataLanguage) ? /*#__PURE__*/_jsx(ShortCard, {
      appearsIn: "filterable-results",
      "data-test-id": `short-${id}`,
      language: language || dataLanguage,
      onClick: () => {
        sendSearchFeedback({
          resultMLOptionId,
          contentContainerType: 'SHORT_FORM_CONTENT'
        }).catch(console.error);
      },
      position: index + 1,
      shortId: Number(id)
    }, id) : contentType === 'TRACK' ? /*#__PURE__*/_jsx(TrackCardContainer, {
      appearsIn: "filterable-results",
      "data-test-id": `track-${id}`,
      onClick: () => {
        sendSearchFeedback({
          resultMLOptionId,
          contentContainerType: 'TRACK'
        }).catch(console.error);
      },
      position: index + 1,
      trackId: Number(id)
    }, id) : /*#__PURE__*/_jsx(LessonCardContainer, {
      appearsIn: "filterable-results",
      "data-test-id": `lesson-${id}`,
      lessonId: Number(id),
      onClick: () => {
        sendSearchFeedback({
          resultMLOptionId,
          contentContainerType: 'TRACK'
        }).catch(console.error);
      },
      position: index + 1
    }, `lesson-${id}`);
  });
  return /*#__PURE__*/_jsxs(CatalogPageWrapper, {
    children: [/*#__PURE__*/_jsx(ResultsStatusBar, {
      cardsTotal: tracksLessonsSearchResultsTotal,
      endCard: endCard,
      loading: tracksLessonsSearchQueryLoading,
      mobileFilterTypes: [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.LEVEL, FILTER_TYPES.DURATION, FILTER_TYPES.CONTENT_TYPE, FILTER_TYPES.LANGUAGE],
      startCard: startCard,
      sticky: true
    }), banners, /*#__PURE__*/_jsxs(UIDashboardPage, {
      contentAreaFlush: !!isMobile,
      headerComponent: null,
      mainSectionStyle: {
        backgroundColor: theme.colors.OLAF
      },
      navHeight: 311,
      children: [isMobile ? /*#__PURE__*/_jsx(MobileFilterSection, {}) : /*#__PURE__*/_jsx(TracksTopFiltersContainer, {}), data.length === 0 && tracksLessonsSearchQueryLoading ? /*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "centered",
        minHeight: 250,
        size: "medium"
      }) : tracksLessonsSearchQueryError ? /*#__PURE__*/_jsx(ApiError, {
        className: "tracks-api-error",
        error: tracksLessonsSearchQueryError,
        marker404: "CATALOG_COURSES_API_404",
        markerDefault: "CATALOG_COURSES_API_ERROR",
        resetLink: pageUrlFragment
      }) : !tracksLessonsSearchQueryData.length && !tracksLessonsSearchQueryLoading ? /*#__PURE__*/_jsx(NavMarker, {
        name: "CATALOG_COURSES_LOADED",
        children: /*#__PURE__*/_jsx(NoResultsError, {
          resetLink: pageUrlFragment
        })
      }) : /*#__PURE__*/_jsx(NavMarker, {
        name: "CATALOG_COURSES_LOADED",
        children: /*#__PURE__*/_jsx(CardsContainer, {
          "data-test-id": "main-catalog-cards-container",
          children: mustPaginateLocally ? /*#__PURE__*/_jsx(PaginatedUICardGrid, {
            limit: 12,
            onPageChange: setPage,
            page: page,
            children: cards
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(UISection, {
              children: /*#__PURE__*/_jsx(UICardGridStyled, {
                children: cards
              })
            }), pageCount > 1 && /*#__PURE__*/_jsx(CatalogSearchPagination, {
              pageCount: pageCount
            })]
          })
        })
      })]
    })]
  });
};